import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  BASKET_SUMMARY_TOTAL,
  BASKET_SUMMARY_ITEMS,
} from '../../../config/text/text';
import { formatCurrency } from '../../../helpers/currency';
import { isMobileViewport } from '../../../helpers/screen';
import ThemeContext from '../../../providers/ThemeProvider';

const PaymentSummary = ({
  currency,
  finalOrderAmount,
  isPostCheckout = false,
  totalQuantity,
  totalQuantityExceptGiftPack,
  vipPaywall,
}) => {
  const theme = useContext(ThemeContext);
  const formattedTotal = formatCurrency(
    currency,
    finalOrderAmount,
    true,
    false,
    false,
  );
  const isMobile = isMobileViewport();

  if (!isMobile && !isPostCheckout && !vipPaywall) {
    return null;
  }

  return (
    <>
      <p className="payment-summary">
        {BASKET_SUMMARY_TOTAL} (
        <strong>
          {totalQuantityExceptGiftPack
            ? totalQuantityExceptGiftPack
            : totalQuantity}
        </strong>{' '}
        {BASKET_SUMMARY_ITEMS}): <strong>{formattedTotal}</strong>
      </p>
      <style jsx>{`
        .payment-summary {
          display: block;
          font-size: 1.5rem;
          text-align: center;
        }
        strong {
          color: ${theme.colors.primary};
          font-weight: normal;
        }
      `}</style>
    </>
  );
};

PaymentSummary.propTypes = {
  currency: PropTypes.string.isRequired,
  finalOrderAmount: PropTypes.number.isRequired,
  isPostCheckout: PropTypes.bool,
  totalQuantity: PropTypes.number.isRequired,
  totalQuantityExceptGiftPack: PropTypes.number,
  vipPaywall: PropTypes.bool,
};

export default PaymentSummary;
